import React from 'react';
import './PharmaciesSite.css';
import { Link } from 'react-router-dom';
import SectionTitle from '../SectionTitle/SectionTitle';
import Button from '../Button/Button';
import Map from '../Map/Map';

const PharmaciesSite = () => {
  return (
    <div className="PharmaciesSite">
      <div className="PharmaciesSite__header">
        <SectionTitle>
          Trouver
          <strong className="SectionTitle__item--bold">
            &nbsp;votre pharmacie
          </strong>
        </SectionTitle>
        <Link className="JoinText__button" to="/nous-rejoindre">
          <Button
            classname="PharmaciesSite__button"
            type="button"
            greenLight={true}
          >
            Rejoignez-nous
          </Button>
        </Link>
      </div>
      <Map />
    </div>
  );
};

export default PharmaciesSite;
